import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
  state.isAuthenticated = false;
};

const productsListSlice = createSlice({
  name: "Products",
  initialState: {
    isLoading: false,
    productsList: [],
  },
  reducers: {
    // login
    getProductsListRequest: (state) => setLoading(state, true),
    getProductsListSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "productsList"),
    getProductsListFailure: (state) => setLoading(state, false),
  },
});

export const {
  getProductsListRequest,
  getProductsListSuccess,
  getProductsListFailure,
} = productsListSlice.actions;

export const productReducerSlice = productsListSlice.reducer;
